import { CheckSquare, DollarSign, Film, User, Gift, Info, Globe } from "react-feather";
import { tt } from "../i18n/tt";
import { lazyI18n } from "../i18n/lazyText";

/**
 * 벨 알림(notification.category) 사전 — NotificationPopover · NotificationListPanel · AdminNotifications 공용.
 *   color  = Chakra 색 토큰(아이콘용)
 *   scheme = Badge colorScheme(어드민 표기용)
 * platform_news 는 공지(announcement.category='platform_news') 발행 시 벨에 복사되는 값이다.
 * 어드민 수동 발송 셀렉트는 MANUAL_SEND_CATEGORIES 만 쓴다 — 소식은 사람이 수동 발송하지 않는다.
 */
export const NOTIFICATION_CATEGORIES = lazyI18n(() => ({
  inspection:    { label: tt("a.b049c520", "검수"),        icon: CheckSquare, color: "brand.500",   scheme: "brand" },
  settlement:    { label: tt("a.15d47b30", "정산"),        icon: DollarSign,  color: "green.500",   scheme: "green" },
  content:       { label: tt("a.5b3fdce0", "콘텐츠"),      icon: Film,        color: "purple.500",  scheme: "purple" },
  account:       { label: tt("a.a456fb71", "계정"),        icon: User,        color: "blue.500",    scheme: "blue" },
  service:       { label: tt("a.d8ab5eae", "서비스"),      icon: Gift,        color: "orange.500",  scheme: "orange" },
  system:        { label: tt("a.b0cc8942", "시스템"),      icon: Info,        color: "neutral.500", scheme: "gray" },
  platform_news: { label: tt("a.ef1922c2", "플랫폼 소식"), icon: Globe,       color: "brand.700",   scheme: "teal" },
}));

export const MANUAL_SEND_CATEGORIES = ["inspection", "settlement", "content", "account", "service", "system"];

export const categoryMeta = (key) => NOTIFICATION_CATEGORIES[key] || NOTIFICATION_CATEGORIES.system;
